import styled from 'styled-components';

const SingleNewsAndEventsStyle = styled.section`
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.mobile-share-link-wrapper {
			display: flex;
			justify-content: center;
			margin-top: var(--sp7x);

			.icons-wrap {
				display: flex;
				margin-top: var(--sp2x);

				.share-item {
					margin: 0 var(--sp1x);
				}
			}

			.share-links-wrap {
				position: relative;
				top: unset;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		.mobile-share-link-wrapper {
			display: flex;
			justify-content: center;
			margin-top: var(--sp5x);

			.icons-wrap {
				display: flex;
				margin-top: var(--sp2x);

				.share-item {
					margin: 0 var(--sp1x);
				}
			}

			.share-links-wrap {
				position: relative;
				top: unset;
			}
		}
	}
`;

export default SingleNewsAndEventsStyle;
